import React from 'react';
import {Button} from 'antd';
import {CommandDto} from '../../../api';
import {EyeOutlined} from "@ant-design/icons";



const PauseRecordCommandModal = ({onCommandCardData, initialData}: { onCommandCardData: Function; initialData?: CommandDto }) => {


    const addCommand = () => {
        let command: CommandDto = {commandType: 'PAUSE_RECORD'};
        onCommandCardData(command);
    };


    return (
        <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
            <Button
                type="primary"
                onClick={addCommand}
                style={{width: '100%', height: '100%'}}
            >
                <EyeOutlined/> Aufzeichnen
            </Button>
        </div>
    );
};

export default PauseRecordCommandModal;
